import roundTo from 'round-to';

const roundToNearest = (num, cents = 1) => {
  const newNum = Number(num);
  const incre = 100 / cents;
  return Math.round(newNum * incre) / incre;
};


const roundUpToNearest = (num, cents = 1) => {
  const newNum = Number(num);
  const incre = 100 / cents;
  return Math.ceil(newNum * incre) / incre;
};

const roundDownToNearest = (num, cents = 1) => {
  const newNum = Number(num);
  const incre = 100 / cents;
  return Math.floor(newNum * incre) / incre;
};

export {
  roundToNearest,
  roundUpToNearest,
  roundDownToNearest,
};



// WEBPACK FOOTER //
// ./src/app/utils/rounding-helpers.js